import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Footer from "../../../customComponents/Footer";
import "./privacy-policy.css";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Privacy Policy – Arab Global Virtual Assets Services L.L.C S.P.C</title>
        <meta
          name="description"
          content="Privacy Policy of Arab Global Virtual Assets Services L.L.C S.P.C, licensed by the Capital Market Authority of the UAE (CMA License No. 20200000447)."
        />
        <meta
          name="keywords"
          content="Arab Global Privacy Policy, Arab Global Virtual Assets Services, CMA License, UAE PDPL, VA MTF privacy policy"
        />
      </Helmet>

      <div className="hero-banner-style top-section-gap privacy_policy">
        <section className="faq_sec">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-lg-10 col-md-12">
                <div className="section-title">
                  <h1 className="text-gradient text-center agcex-pp-title-uppercase">PRIVACY POLICY</h1>
                  <p className="text-center text-light mt-2 agcex-pp-company-subtitle">
                    Arab Global Virtual Assets Services L.L.C S.P.C
                  </p>
                  <p className="text-center text-muted agcex-pp-license-detail-sm">
                    Licensed by the Capital Market Authority of the United Arab Emirates<br />
                    Category 6 License - Multilateral Trading Facility dedicated to Virtual Assets (VA MTF)<br />
                    CMA License No.: 20200000447
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="agcex-pp-page">
          <div className="container">
            {/* Meta Information / Hero */}
            <div className="agcex-pp-hero">
              <div className="agcex-pp-meta">
                <span><i className="ri-shield-check-line" /> CMA License No.: 20200000447</span>
                <span><i className="ri-calendar-line" /> Effective Date: 10th September, 2026</span>
                <span><i className="ri-refresh-line" /> Version: 1.2</span>
              </div>
            </div>

            {/* Content Card */}
            <div className="agcex-pp-card">

              {/* Document Control and Approval Table */}
              <h3 className="agcex-pp-card-subtitle">
                Document Control and Approval
              </h3>
              <div className="agcex-pp-summary-table-wrapper">
                <table className="agcex-pp-summary-table">
                  <tbody>
                    <tr>
                      <td className="agcex-pp-label">Document Owner</td>
                      <td className="agcex-pp-value">Compliance Officer</td>
                    </tr>
                    <tr>
                      <td className="agcex-pp-label">Approved By</td>
                      <td className="agcex-pp-value">Board of Directors on 2nd September, 2026</td>
                    </tr>
                    <tr>
                      <td className="agcex-pp-label">Version</td>
                      <td className="agcex-pp-value">1.2</td>
                    </tr>
                    <tr>
                      <td className="agcex-pp-label">Effective Date</td>
                      <td className="agcex-pp-value">10th September, 2026</td>
                    </tr>
                    <tr>
                      <td className="agcex-pp-label">Related Documents</td>
                      <td className="agcex-pp-value">Data Retention Schedule</td>
                    </tr>
                    <tr>
                      <td className="agcex-pp-label">Next Scheduled Review</td>
                      <td className="agcex-pp-value">10th September, 2027</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Table of Contents */}
              {/* <div className="agcex-pp-section mb-4">
                <h3 className="agcex-pp-card-subtitle">Contents</h3>
                <div className="agcex-pp-table-responsive">
                  <table className="agcex-pp-purpose-table agcex-pp-bordered-table">
                    <thead>
                      <tr>
                        <th style={{ width: "80px" }}>No.</th>
                        <th>Section Title</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>1</td><td>Introduction</td></tr>
                      <tr><td>2</td><td>Scope and Key Definitions</td></tr>
                      <tr><td>3</td><td>Data Controller and Contact Details</td></tr>
                      <tr><td>4</td><td>Personal Data We Collect (4.1 Identity & KYC, 4.2 Account & Transaction, 4.3 Technical & Usage, 4.4 Communications & Support)</td></tr>
                      <tr><td>5</td><td>How We Collect Personal Data</td></tr>
                      <tr><td>6</td><td>Purposes of Processing and Legal Basis</td></tr>
                      <tr><td>7</td><td>Disclosure and Sharing of Personal Data</td></tr>
                      <tr><td>8</td><td>Travel Rule</td></tr>
                      <tr><td>9</td><td>Disclosures to Law Enforcement, Regulators and Legal Authorities</td></tr>
                      <tr><td>10</td><td>Cross-Border Transfer of Personal Data</td></tr>
                      <tr><td>11</td><td>International Blockchain Disclosures</td></tr>
                      <tr><td>12</td><td>Data Retention</td></tr>
                      <tr><td>13</td><td>Your Rights as a Data Subject</td></tr>
                      <tr><td>14</td><td>How We Protect Your Personal Data</td></tr>
                      <tr><td>15</td><td>Personal Data Breach Notification</td></tr>
                      <tr><td>16</td><td>Children's Privacy</td></tr>
                      <tr><td>17</td><td>Personal Data of Employees, Contractors, and Applicants</td></tr>
                      <tr><td>18</td><td>Automated Decision-Making and Profiling</td></tr>
                      <tr><td>19</td><td>Third-Party Websites and Services</td></tr>
                      <tr><td>20</td><td>Changes to this Policy</td></tr>
                      <tr><td>21</td><td>How to Contact Us</td></tr>
                    </tbody>
                  </table>
                </div>
              </div> */}

              {/* Section 1 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">1</span> 1. Introduction</h2>
                <p>
                  Arab Global Virtual Assets Services L.L.C S.P.C (the “Company,” “we,” “us,” or “our”) is a company incorporated in the United Arab Emirates and licensed by the Capital Market Authority (CMA) to operate a Multilateral Trading Facility dedicated to Virtual Assets under a Category 6 (VA MTF) license (the “License”). We operate a virtual asset trading platform (the “Platform”) that facilitates the multilateral trading of approved virtual assets among Platform participants.
                </p>
                <p>
                  This Privacy Policy (the “Policy”) explains how we collect, use, disclose, store, transfer, and otherwise process personal data in connection with the Platform, our website, mobile or web applications, and related services (collectively, the “Services”), and describes the rights available to individuals whose personal data we process.
                </p>
                <p>
                  By accessing or using the Services, registering as a Platform participant, or otherwise providing personal data to us, you acknowledge that you have read and understood this Policy. Where consent is our legal basis for processing, we will obtain that consent separately and you may withdraw it as described in Section 13. Use of the Services indicates that you accept and agree to be bound by this Policy; if you do not agree with it, you should not use the Services.
                </p>
              </div>

              {/* Section 2 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">2</span> 2. Scope and Key Definitions</h2>
                <p>
                  This Policy applies to personal data of the following categories of individuals (“you” or “Data Subjects”):
                </p>
                <ul>
                  <li>Prospective, current, and former Platform participants (individual clients) and their authorised users;</li>
                  <li>Individuals acting as beneficial owners, directors, authorised signatories, or representatives of corporate or institutional participants;</li>
                  <li>Visitors to our website and users of our applications;</li>
                  <li>Individuals contacting our customer support or compliance functions; and</li>
                  <li>Employees, contractors, and job applicants of the Company (addressed at a summary level in Section 17; a separate internal HR privacy notice governs employee data in detail).</li>
                </ul>
                <p>Key terms used in this Policy have the meanings set out in the Definitions table below:</p>

                <div className="agcex-pp-table-responsive">
                  <table className="agcex-pp-purpose-table agcex-pp-bordered-table">
                    <thead>
                      <tr>
                        <th className="agcex-pp-term-col-wide">Term</th>
                        <th>Meaning</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><strong>Personal Data</strong></td>
                        <td>Any data relating to an identified natural person, or a natural person who can be identified directly or indirectly, by reference to an identifier such as name, voice, image, identification number, electronic identifier, location data, or physical, physiological, cultural, economic or social identity.</td>
                      </tr>
                      <tr>
                        <td><strong>Processing</strong></td>
                        <td>Any operation performed on Personal Data, whether or not by automated means, including collection, recording, organisation, storage, adaptation, retrieval, use, disclosure, transmission, and erasure.</td>
                      </tr>
                      <tr>
                        <td><strong>Data Controller</strong></td>
                        <td>The entity that determines the purposes and means of Processing Personal Data - in respect of Platform data, this is the Company.</td>
                      </tr>
                      <tr>
                        <td><strong>Data Processor</strong></td>
                        <td>An entity that Processes Personal Data on behalf of, and under the instructions of, the Data Controller.</td>
                      </tr>
                      <tr>
                        <td><strong>Virtual Asset (VA)</strong></td>
                        <td>A digital representation of value that may be digitally traded or transferred and used for investment purposes, as defined under the CMA VA Framework, excluding digital representations of fiat currencies and securities.</td>
                      </tr>
                      <tr>
                        <td><strong>Platform Participant</strong></td>
                        <td>A natural or legal person onboarded by the Company to access and trade on the VA MTF.</td>
                      </tr>
                      <tr>
                        <td><strong>Authorized Agent</strong></td>
                        <td>A third party you have knowingly and expressly permitted to access or act on your Platform account on your behalf (e.g., a portfolio-tracking tool or an authorised representative), subject to Section 7. This includes any 'Authorized Individual' as defined in our Terms of Use.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Section 3 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">3</span> 3. Data Controller and Contact Details</h2>
                <p>For the purposes of the UAE PDPL, the Data Controller in respect of the personal data described in this Policy is:</p>
                <div className="agcex-pp-summary-table-wrapper">
                  <table className="agcex-pp-summary-table">
                    <tbody>
                      <tr>
                        <td className="agcex-pp-label">Legal Name</td>
                        <td className="agcex-pp-value">Arab Global Virtual Assets Services L.L.C S.P.C</td>
                      </tr>
                      <tr>
                        <td className="agcex-pp-label">CMA License Number</td>
                        <td className="agcex-pp-value">20200000447, Category 6 - VA MTF</td>
                      </tr>
                      <tr>
                        <td className="agcex-pp-label">Registered Address</td>
                        <td className="agcex-pp-value">Office ADCP Tower C1603, Electra Street, Abu Dhabi, UAE</td>
                      </tr>
                      <tr>
                        <td className="agcex-pp-label">Contact E-mail (General)</td>
                        <td className="agcex-pp-value"><a href="mailto:contactus@arabglobal.ae">contactus@arabglobal.ae</a></td>
                      </tr>
                      <tr>
                        <td className="agcex-pp-label">Data Protection / Compliance Officer</td>
                        <td className="agcex-pp-value"><a href="mailto:compliance@arabglobal.ae">compliance@arabglobal.ae</a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Section 4 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">4</span> 4. Personal Data We Collect</h2>
                <p>We collect the following categories of personal data, depending on your relationship with us and the Services you use:</p>

                <div className="agcex-pp-sub-article">
                  <h3>4.1 Identity and Onboarding (KYC) Data</h3>
                  <ul>
                    <li>Full name, date of birth, nationality, gender, photograph;</li>
                    <li>Copies of government-issued identification documents (passport, Emirates ID, visa) and, for corporate participants, incorporation documents, shareholding/ownership structure, and beneficial ownership information;</li>
                    <li>Proof of address and residency status;</li>
                    <li>Source of funds and source of wealth declarations;</li>
                    <li>Politically exposed person (PEP), sanctions, and adverse media screening results; and</li>
                    <li>Biometric data collected during identity verification, including facial images and liveness-check data, and, where you enable Biometric Authentication, fingerprint or facial recognition data (processed as sensitive personal data, with appropriate safeguards and, where required by the UAE PDPL, your consent).</li>
                  </ul>
                </div>

                <div className="agcex-pp-sub-article">
                  <h3>4.2 Account and Transaction Data</h3>
                  <ul>
                    <li>Account credentials, participant/account identifiers, and authentication data (e.g., two-factor authentication records and, where you enable Biometric Authentication on your device, associated biometric verification records);</li>
                    <li>Order, trade, execution, and settlement data on the VA MTF, including counterparties, instruments traded, timestamps, and pricing;</li>
                    <li>Virtual asset wallet addresses and, where applicable, blockchain transaction identifiers associated with deposits and withdrawals;</li>
                    <li>Bank account and payment details used to fund or withdraw from your account; and</li>
                    <li>Trading history, order book activity, margin/exposure data, and risk profiling information.</li>
                  </ul>
                </div>

                <div className="agcex-pp-sub-article">
                  <h3>4.3 Technical and Usage Data</h3>
                  <ul>
                    <li>IP address, device identifiers, browser type and settings, and operating system; and</li>
                    <li>Log-in timestamps, session data, geolocation data (where enabled), language preferences, and platform usage analytics.</li>
                  </ul>
                  <p>
                    <strong>Cookies and similar technologies:</strong> Our website and applications use cookies and similar technologies to operate and secure the Services, remember your preferences, and analyse usage. Where required by Applicable Law, non-essential cookies are used only with your consent, and you may manage your preferences through your browser settings or our cookie banner. A separate Cookie Notice on our website provides further detail.
                  </p>
                </div>

                <div className="agcex-pp-sub-article">
                  <h3>4.4 Communications and Support Data</h3>
                  <ul>
                    <li>Records of correspondence with our customer support, compliance, and relationship management teams, including call recordings (where notified) and support tickets; and</li>
                    <li>Complaints, feedback, and survey responses.</li>
                  </ul>
                </div>
              </div>

              {/* Section 5 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">5</span> 5. How We Collect Personal Data</h2>
                <ul>
                  <li>Directly from you, when you register for an account, complete onboarding/KYC, place orders, contact support, or otherwise interact with the Services;</li>
                  <li>Automatically, through your use of our website, applications, and Platform (e.g., server logs, device information);</li>
                  <li>From third parties, including identity verification and screening providers, banking and payment partners, correspondent institutions, credit reference or fraud-prevention agencies, publicly available sources (e.g., corporate registries, sanctions lists), and, where relevant, blockchain analytics providers used to monitor virtual asset transactions for AML/CFT purposes; and</li>
                  <li>From other Platform participants, where transactional or counterparty information is generated as part of order matching and settlement on the VA MTF.</li>
                </ul>
              </div>

              {/* Section 6 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">6</span> 6. Purposes of Processing and Legal Basis</h2>
                <p>We process personal data for the purposes, and on the legal bases available under the UAE PDPL, summarised below:</p>

                <div className="agcex-pp-table-responsive">
                  <table className="agcex-pp-purpose-table agcex-pp-bordered-table">
                    <thead>
                      <tr>
                        <th>Purpose</th>
                        <th>Legal Basis under UAE PDPL</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><strong>Onboarding participants, verifying identity, and performing KYC/CDD/EDD checks</strong></td>
                        <td>Compliance with a legal obligation (AML/CFT and CMA VA Framework requirements); performance of a contract</td>
                      </tr>
                      <tr>
                        <td><strong>Operating and maintaining the VA MTF, including order matching, execution, clearing and settlement</strong></td>
                        <td>Performance of a contract; legitimate interest in operating the Platform</td>
                      </tr>
                      <tr>
                        <td><strong>Monitoring transactions, screening for sanctions/PEP status, and reporting suspicious activity</strong></td>
                        <td>Compliance with a legal obligation under UAE AML/CFT Law and CMA requirements</td>
                      </tr>
                      <tr>
                        <td><strong>Regulatory reporting to the CMA and other competent UAE authorities</strong></td>
                        <td>Compliance with a legal obligation</td>
                      </tr>
                      <tr>
                        <td><strong>Risk management, market surveillance, and prevention of market abuse or manipulation</strong></td>
                        <td>Compliance with a legal obligation; legitimate interest</td>
                      </tr>
                      <tr>
                        <td><strong>Customer support, account administration, and communications about the Services</strong></td>
                        <td>Performance of a contract; legitimate interest</td>
                      </tr>
                      <tr>
                        <td><strong>Marketing communications about new products or features</strong></td>
                        <td>Consent (which may be withdrawn at any time)</td>
                      </tr>
                      <tr>
                        <td><strong>Improving, testing, and securing the Platform, and preventing fraud or cyber-incidents</strong></td>
                        <td>Legitimate interest; compliance with a legal obligation</td>
                      </tr>
                      <tr>
                        <td><strong>Establishing, exercising, or defending legal claims</strong></td>
                        <td>Legitimate interest; compliance with a legal obligation</td>
                      </tr>
                      <tr>
                        <td><strong>Biometric identity verification during onboarding and Biometric Authentication (where you enable it)</strong></td>
                        <td>Consent; compliance with a legal obligation (identity verification under UAE AML/CFT Law and CMA requirements)</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <p>
                  Where we rely on consent, you may withdraw it at any time without affecting the lawfulness of processing carried out before withdrawal, save that withdrawal may affect our ability to provide certain Services, including maintaining your Platform account where the data concerned is required for regulatory purposes.
                </p>
              </div>

              {/* Section 7 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">7</span> 7. Disclosure and Sharing of Personal Data</h2>
                <p>We disclose personal data only where necessary and to the following categories of recipients:</p>
                <ul>
                  <li>The Capital Market Authority (CMA) and other competent UAE regulatory, judicial, tax, and law-enforcement authorities, pursuant to Applicable Law, including in response to lawful requests for information and mandatory regulatory reporting (see Section 9);</li>
                  <li>The UAE Financial Intelligence Unit, where suspicious transaction or activity reports are required under UAE AML/CFT Law;</li>
                  <li>Correspondent banks, payment service providers, and custodians involved in processing deposits, withdrawals, and settlement;</li>
                  <li>Identity verification, screening, blockchain analytics, and fraud-prevention service providers engaged as Data Processors under contract;</li>
                  <li>Our corporate group companies and affiliates, solely for the purposes described in this Policy and subject to confidentiality and data protection obligations at least as protective as those in this Policy;</li>
                  <li>Professional advisers (legal, audit, tax) and insurers, where necessary for their engagement;</li>
                  <li>IT infrastructure, cloud hosting, and cybersecurity service providers who support the Platform, subject to appropriate data processing agreements and security controls;</li>
                  <li>Other Platform participants, but only to the limited extent necessary to complete a matched trade (e.g., counterparty and settlement details required to execute a transaction), and never more than is required for that transaction;</li>
                  <li>An Authorized Agent, where you have expressly and knowingly granted that third party permission to access or act on your account - you remain responsible for any access or instructions given through an Authorized Agent, and we are not responsible for that third party's own handling of your data, which is governed by its own privacy policy; and</li>
                  <li>A successor entity in the event of a merger, acquisition, restructuring, or sale of assets, subject to equivalent confidentiality and data protection commitments.</li>
                </ul>
                <p>
                  We do not sell personal data to third parties. Any sharing with Data Processors is governed by written agreements that require the processor to implement appropriate technical and organisational measures and to process personal data only on our documented instructions.
                </p>
              </div>

              {/* Section 8 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">8</span> 8. Travel Rule</h2>
                <p>
                  Personal information relating to virtual asset transfers may be shared with other regulated Virtual Asset Service Providers where required under applicable AML/CFT legislation and the FATF Travel Rule.
                </p>
                <p>
                  Where you send or receive virtual assets to or from another Virtual Asset Service Provider, we may be required to collect, verify, and transmit originator and beneficiary information (such as full name and, where applicable, account or wallet identifiers) to or from that counterparty provider before the transaction can be completed, using secure and encrypted channels. Where a transfer involves an unhosted or personal wallet, we may require you to confirm and verify ownership of that wallet before we can process the transaction. We only share Travel Rule information with counterparties that we reasonably believe are licensed, regulated, or otherwise subject to equivalent AML/CFT and data protection obligations.
                </p>
              </div>

              {/* Section 9 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">9</span> 9. Disclosures to Law Enforcement, Regulators and Legal Authorities</h2>
                <p>
                  In addition to routine regulatory reporting described in Section 7, we may access, preserve, and disclose personal data (including account, transaction, and communications data) to competent UAE or foreign regulatory, judicial, or law-enforcement authorities where we have a good-faith belief that doing so is necessary to:
                </p>
                <ul>
                  <li>Comply with a court order, subpoena, production order, or other lawful legal process, or a formal request from a competent regulatory or law-enforcement authority;</li>
                  <li>Investigate, prevent, or take action regarding suspected or actual illegal activity, fraud, money laundering, terrorist financing, sanctions evasion, or other violations of Applicable Law or of our Terms of Use;</li>
                  <li>Enforce our agreements with you, or protect the rights, property, or safety of the Company, our participants, or the public;</li>
                  <li>Respond to an emergency that we believe in good faith requires disclosure to prevent death, serious bodily harm, or significant financial loss; or</li>
                  <li>Where your account or activity becomes the subject of a governmental proceeding, criminal investigation, or dispute, to the extent reasonably necessary to respond to that proceeding or investigation.</li>
                </ul>
                <p>
                  Where legally permitted to do so, we will make reasonable efforts to notify you before disclosing your personal data in response to such a request. We may be legally prohibited from providing such notice (for example, where a suspicious transaction report or an AML/CFT-related disclosure is subject to a statutory “tipping-off” prohibition).
                </p>
              </div>

              {/* Section 10 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">10</span> 10. Cross-Border Transfer of Personal Data</h2>
                <p>
                  Personal data is primarily hosted and processed within the United Arab Emirates. Where it is necessary to transfer personal data outside the UAE (for example, to a cloud service provider, a group entity, or a correspondent institution located abroad), we will only do so where the UAE PDPL's conditions for cross-border transfer are satisfied, which may include:
                </p>
                <ul>
                  <li>The destination country or territory being recognised as providing an adequate level of protection by the competent UAE authority (currently the UAE Data Office);</li>
                  <li>Execution of standard contractual clauses or other appropriate safeguards approved under the UAE PDPL;</li>
                  <li>The transfer being necessary for the performance of a contract with you, or for important reasons of public interest;</li>
                  <li>Your explicit consent to the transfer, after being informed of the possible risks of such transfer in the absence of the safeguards above.</li>
                </ul>
                <p>
                  Where virtual asset transactions involve distributed ledger infrastructure that is by nature decentralised or hosted across multiple jurisdictions, we take reasonable steps to ensure that personal data associated with wallet addresses or transaction metadata is protected consistently with this Section and Applicable Law.
                </p>
              </div>

              {/* Section 11 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">11</span> 11. International Blockchain Disclosures</h2>
                <p>
                  Transactions involving public blockchains may result in wallet addresses, transaction hashes and related metadata becoming permanently recorded on distributed ledger networks. Although wallet addresses do not directly identify individuals, they may constitute personal data under applicable law when linked to an identifiable person.
                </p>
                <p>
                  Public blockchain networks are decentralised by design and may be operated, validated, and replicated by nodes located in multiple jurisdictions outside the UAE, over which we have no control. Once a transaction is broadcast to a public blockchain, the resulting record is generally immutable and cannot be deleted, corrected, or withdrawn by us or by you, including via blockchain explorers or similar public tools; accordingly, the rights to erasure, rectification, and restriction described in Section 13 cannot be exercised over data recorded directly on a public blockchain. We may use blockchain analytics tools, as described in Section 5, to associate on-chain activity with your account for AML/CFT, sanctions screening, and fraud-prevention purposes.
                </p>
              </div>

              {/* Section 12 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">12</span> 12. Data Retention</h2>
                <p>
                  We retain personal data only for as long as necessary to fulfil the purposes described in this Policy, including to satisfy regulatory, accounting, tax, and legal requirements. In particular:
                </p>
                <ul>
                  <li>KYC/CDD records, transaction records, and related supporting documentation are retained for a minimum period following the end of the business relationship or the date of the transaction, as required under UAE AML/CFT Law and applicable CMA record-keeping requirements (UAE AML/CFT Law requires a minimum of five (5) years; consistent with our Terms of Use, these records are retained for eight (8) years following the end of the business relationship or the date of the transaction, or such longer period as required by Applicable Law or a competent authority);</li>
                  <li>Trade, order, and market-surveillance data (including audit trails and system logs) are retained in accordance with CMA record-keeping and audit-trail requirements applicable to VA MTF operators;</li>
                  <li>Website and technical/usage data is retained for a shorter period necessary for security, analytics, and troubleshooting purposes, unless a longer period is required for legal or dispute-resolution purposes; it is not indefinitely retained but is deleted or anonymised on a rolling basis in line with our retention schedule; and</li>
                  <li>Marketing data is retained until you withdraw consent or object to further processing.</li>
                </ul>
                <p>
                  Upon expiry of the applicable retention period, we securely delete, anonymise, or archive personal data in accordance with our internal Data Retention Schedule and disposal procedures.
                </p>
              </div>

              {/* Section 13 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">13</span> 13. Your Rights as a Data Subject</h2>
                <p>
                  Subject to the exceptions and conditions set out in the UAE PDPL (including exceptions that apply where processing is necessary for compliance with a legal obligation, such as AML/CFT and CMA regulatory requirements), you have the following rights in relation to your personal data:
                </p>
                <ul>
                  <li><strong>Right to be informed</strong> - to receive clear information about how your personal data is processed (as set out in this Policy);</li>
                  <li><strong>Right of access</strong> - to request confirmation of whether we process your personal data and to obtain a copy of it;</li>
                  <li><strong>Right to rectification</strong> - to request correction of inaccurate or incomplete personal data;</li>
                  <li><strong>Right to erasure</strong> - to request deletion of your personal data, where applicable (this right does not apply to records we are required to retain under AML/CFT or CMA regulatory obligations);</li>
                  <li><strong>Right to restrict processing</strong> - to request that we limit the processing of your personal data in certain circumstances;</li>
                  <li><strong>Right to data portability</strong> - to request your personal data in a structured, commonly used, machine-readable format, where technically feasible;</li>
                  <li><strong>Right to object</strong> - to object to processing carried out on the basis of legitimate interest or for direct marketing purposes;</li>
                  <li><strong>Right to withdraw consent</strong> - where processing is based on consent, to withdraw it at any time; and</li>
                  <li><strong>Right to lodge a complaint</strong> - with the UAE Data Office or other competent supervisory authority if you believe your rights have been infringed.</li>
                </ul>
                <p>
                  To exercise any of these rights, please contact us using the details in Section 3. We will respond within the timeframe prescribed by the UAE PDPL and its executive regulations. We may need to verify your identity before actioning a request and may decline or limit a request to the extent permitted by Applicable Law (for example, where the data is required for regulatory record-keeping).
                </p>
              </div>

              {/* Section 14 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">14</span> 14. How We Protect Your Personal Data</h2>
                <p>
                  As a licensed VA MTF operator, the Company maintains a security programme aligned with CMA VA Framework requirements for robust security procedures and safe custody of assets and data, and with the UAE PDPL's requirement to implement appropriate technical and organisational measures. These measures include, as applicable:
                </p>
                <ul>
                  <li>Encryption of personal data in transit and at rest;</li>
                  <li>Role-based access controls, multi-factor authentication, and the principle of least privilege for staff and system access;</li>
                  <li>Secure storage and management of cryptographic keys and virtual asset wallets, segregated from general IT systems;</li>
                  <li>Network security controls, including firewalls, intrusion detection/prevention systems, and regular vulnerability assessments and penetration testing;</li>
                  <li>Routine systems maintenance, patching, and change-management procedures;</li>
                  <li>Business continuity and disaster recovery arrangements;</li>
                  <li>Employee background checks, confidentiality undertakings, and periodic data protection and cybersecurity training;</li>
                  <li>Logging and monitoring of access to systems holding personal data and virtual assets; and</li>
                  <li>Periodic review and audit of the above controls, including by internal audit and, where applicable, independent third parties.</li>
                </ul>
                <p>
                  Despite these measures, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security. You are responsible for safeguarding your own account credentials and for enabling the security features we make available (such as two-factor authentication) and for promptly notifying us of any suspected unauthorised access to your account. We maintain an incident response plan designed to detect, contain, and remediate security incidents promptly.
                </p>
              </div>

              {/* Section 15 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">15</span> 15. Personal Data Breach Notification</h2>
                <p>
                  In the event of a personal data breach that is likely to result in a risk to the privacy, rights, and interests of affected individuals, we will, in accordance with the UAE PDPL:
                </p>
                <ul>
                  <li>Notify the UAE Data Office (or successor competent authority) without undue delay upon becoming aware of the breach;</li>
                  <li>Notify affected Data Subjects without undue delay where the breach is likely to result in a high risk to their rights and interests;</li>
                  <li>Notify the CMA in accordance with applicable incident-reporting obligations under the CMA VA Framework; and</li>
                  <li>Take prompt remedial action to contain and mitigate the impact of the breach.</li>
                </ul>
              </div>

              {/* Section 16 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">16</span> 16. Children's Privacy</h2>
                <p>
                  The Services are intended for use only by individuals who meet the minimum age and legal capacity requirements to open a Platform account under Applicable Law and our Terms of Use, and are not directed at, or intended for use by, children. We do not knowingly collect personal data from children. If we become aware that we have inadvertently collected personal data from a child in violation of this Policy, we will take reasonable steps to delete that data promptly. If you believe a child has provided us with personal data, please contact us using the details in Section 3.
                </p>
              </div>

              {/* Section 17 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">17</span> 17. Personal Data of Employees, Contractors, and Applicants</h2>
                <p>
                  Where the Company processes personal data of its employees, contractors, and job applicants (for example, for recruitment, payroll, benefits administration, performance management, and compliance with UAE labour and immigration law), such processing is governed by our internal HR privacy notice, applied consistently with the principles in this Policy and the UAE PDPL. This Policy does not limit any additional obligations arising under UAE labour law.
                </p>
              </div>

              {/* Section 18 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">18</span> 18. Automated Decision-Making and Profiling</h2>
                <p>
                  We may use automated tools to support transaction monitoring, sanctions/PEP screening, fraud detection, and market surveillance (for example, flagging unusual trading patterns or transaction risk scores). Where such processing produces a legal or similarly significant effect on you (for example, restricting your Platform account), we ensure appropriate human oversight and provide, on request and subject to Applicable Law, information about the logic involved and the right to request human review, except where the processing is required by law (e.g., mandatory sanctions screening) or necessary to prevent fraud or financial crime.
                </p>
              </div>

              {/* Section 19 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">19</span> 19. Third-Party Websites and Services</h2>
                <p>
                  The Services may contain links to third-party websites, wallets, or blockchain explorers that are not operated by us. Any access to and use of such linked services is governed by the privacy policy and terms of that third party, and not by this Policy, and we are not responsible for the privacy or data-handling practices of any such third party. We encourage you to review the relevant privacy notice before providing personal data to any linked third-party site or service.
                </p>
              </div>

              {/* Section 20 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">20</span> 20. Changes to this Policy</h2>
                <p>
                  We may update this Policy from time to time to reflect changes in our practices, the Services, or Applicable Law, including updates to the CMA VA Framework or the UAE PDPL. We will publish the updated Policy on our website and/or Platform with a revised “Last Reviewed” date, and, where the changes are material, we will provide additional notice (for example, by e-mail or an in-Platform notification) and, where required by Applicable Law, seek your consent before the changes take effect.
                </p>
              </div>

              {/* Section 21 */}
              <div className="agcex-pp-section">
                <h2><span className="agcex-pp-section-number">21</span> 21. How to Contact Us</h2>
                <p>
                  If you have questions, concerns, or requests regarding this Policy or our processing of your personal data, please contact:
                </p>
                <div className="agcex-pp-summary-table-wrapper agcex-pp-contact-table-wrapper">
                  <table className="agcex-pp-summary-table">
                    <tbody>
                      <tr>
                        <td className="agcex-pp-label">Data Protection Officer / Compliance Officer</td>
                        <td className="agcex-pp-value"><a href="mailto:compliance@arabglobal.ae">compliance@arabglobal.ae</a></td>
                      </tr>
                      <tr>
                        <td className="agcex-pp-label">Postal Address</td>
                        <td className="agcex-pp-value">Office ADCP Tower C1603, Electra Street, Abu Dhabi, UAE</td>
                      </tr>
                      <tr>
                        <td className="agcex-pp-label">Telephone</td>
                        <td className="agcex-pp-value"><a href="tel:+971502760715">+971 502760715</a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p>
                  If you are not satisfied with our response, you have the right to lodge a complaint with the UAE Data Office, and, in respect of matters concerning our conduct as a licensed VA MTF operator, with the Capital Market Authority.
                </p>
              </div>

              {/* Divider & Copyright */}
              <hr className="agcex-pp-divider" />
              <div className="agcex-pp-footer-grid">
                <div className="agcex-pp-footer-col">
                  <strong>Arab Global Virtual Assets Services L.L.C S.P.C</strong>
                  <span>Category 6 License - VA MTF</span>
                  <span>Abu Dhabi, United Arab Emirates</span>
                </div>
                <div className="agcex-pp-footer-col">
                  <strong>Regulatory Approval</strong>
                  <span>CMA License No.: 20200000447</span>
                  <span>Effective: 10th September, 2026 (v1.2)</span>
                </div>
                <div className="agcex-pp-footer-col">
                  <strong>Contact</strong>
                  <span><a href="mailto:contactus@arabglobal.ae">contactus@arabglobal.ae</a></span>
                  <span><a href="mailto:compliance@arabglobal.ae">compliance@arabglobal.ae</a></span>
                </div>
              </div>

              <div className="agcex-pp-copyright">
                © 2026 Arab Global Virtual Assets Services L.L.C S.P.C. All rights reserved. Version 1.2.
              </div>

            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;